<template>
    <!-- Container START -->
    <div>
        <div class="container">
            <div class="row g-4">
                <!-- Main content START -->
                <div class="col-lg-8 mx-auto" style="direction: rtl;">
                    <Header pageTitle="من نحن" />
                    <!-- About Us START -->
                    <div class="card" style="margin-top: 70px;">
                        <div class="card-header">
                            <p style="font-weight: bold; font-size: large;" class="card-title mb-0">من نحن</p>
                        </div>
                        <div class="card-body">
                            <p><strong>من نحن في تطبيق "إتقان"</strong></p>
                            <p>
                                نحن فريق "إتقان"، منصة رقمية مبتكرة تأسست بهدف إحداث تحوّل في عالم العمل الحر، وبناء جسرٍ رقمي يربط بين المواهب المتميزة وأصحاب المشاريع بكل سهولة وشفافية.
                                نؤمن بأن كل شخص يمتلك مهارات استثنائية تستحق أن تُقدَّم للعالم، وأن كل مشروعٍ يحتاج إلى يدٍ محترفة تُنجزه بإتقان.
                            </p>
                            <p>
                                تأسس التطبيق عام 2023 كحلٍ رقمي شامل يواجه التحديات التي تعترض طريق المستقلين والعملاء، من صعوبة في الوصول إلى الخدمات الموثوقة إلى تعقيدات إدارة المشاريع.
                                نسعى جاهدين لخلق بيئة عمل مرنة تحفظ حقوق الجميع، وتعزز الثقة المتبادلة، وتضمن تجربةً سلسة من بداية التعاقد حتى تسليم العمل.
                            </p>
                            
                            <!-- Divider -->
                            <hr class="mt-2 mb-4">
                            
                            <p><strong>رؤيتنا</strong></p>
                            <p>أن نكون المنصة الرائدة عربيًا في تمكين الأفراد والشركات من تحقيق أهدافهم عبر توظيف المهارات المناسبة في الوقت المناسب.</p>
                            
                            <!-- Divider -->
                            <hr class="mt-2 mb-4">
                            
                            <p><strong>مهمتنا</strong></p>
                            <p>
                                توفير مساحة آمنة ومبتكرة تتيح للمستقلين عرض مهاراتهم، وللعملاء إيجاد الحلول المثالية لمتطلباتهم، مع ضمان جودة الخدمات عبر أنظمة مراجعة وتقييم متطورة.
                            </p>
                            
                            <!-- Divider -->
                            <hr class="mt-2 mb-4">
                            
                            <p><strong>ما يميزنا</strong></p>
                            <ul>
                                <li><strong>التخصيص:</strong> نقدم تجربة مُخصصة لكل مستخدم بناءً على مهاراته أو احتياجاته.</li>
                                <li><strong>الشفافية:</strong> نضمن سياسات واضحة للدفع، والتسعير، وحل النزاعات.</li>
                                <li><strong>الدعم المستمر:</strong> فريق دعم فنيّ ومهنيّ متاح على مدار الساعة.</li>
                                <li><strong>التطوير الدائم:</strong> نعمل على تحسين المنصة باستمرار بناءً على ملاحظاتكم.</li>
                            </ul>
                            
                            <!-- Divider -->
                            <hr class="mt-2 mb-4">
                            
                            <p><strong>فريقنا</strong></p>
                            <p>
                                نحن مجموعة من خبراء التكنولوجيا، ومصممي التجارب الرقمية، ورواد الأعمال الذين يجمعهم شغفٌ بإحداث تأثير إيجابي في سوق العمل الحر.
                                نلتزم بمعايير الجودة العالمية، ونضع خصوصيتكم وأمان بياناتكم على رأس أولوياتنا.
                            </p>
                            
                            <!-- Divider -->
                            <hr class="mt-2 mb-4">
                            
                            <p><strong>انضم إلينا</strong></p>
                            <p>
                                انضم إلينا في رحلتنا لبناء مستقبلٍ حيث تصبح الإنجازات الاستثنائية واقعًا ملموسًا!
                            </p>
                            
                            <p><strong>فريق "إتقان"</strong></p>
                            <p><a href="#">info@itqan-app.com</a></p>
                        </div>
                    </div>
                    <!-- About Us END -->
                </div>
            </div> <!-- Row END -->
        </div>
        <Footer />
    </div>
    <!-- Container END -->
</template>

<script>
import Header from "../../components/header.vue";
import Footer from "../../components/footer.vue";

export default {
    components: {
        Header,
        Footer,
    },
};
</script>

<style scoped></style>
